// theming/ThemeCardGridSkeleton.jsx
import React from 'react';
import { Skeleton } from '@dashboard/components/ui/skeleton';

const PLACEHOLDER_COUNT = 6;

export function ThemeCardGridSkeleton({ count = PLACEHOLDER_COUNT }) {
  return (
    <div className="grid grid-cols-3 gap-2" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-[10px] border border-input bg-white dark:bg-background"
        >
          <Skeleton className="h-[86px] rounded-none" />
          <div className="space-y-1.5 px-3 py-2">
            <Skeleton className="h-3 w-2/3" />
            <Skeleton className="h-2.5 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ThemeCardGridSkeleton;
